import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TRANSLATE_REQUEST_HEADER, getOptionsWithTranslateHeader } from '@os-components';
import { Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { SearchResultResponse } from './search.interface';

type SearchResultWithMetaData = { result: SearchResultResponse; triggeredByLanguageChange: boolean };

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    public constructor(private http: HttpClient) {}

    public getSearchResult(searchTerm: string[]): Observable<SearchResultWithMetaData> {
        // Not using SEARCH_TERM_SEPARATOR constant here because UI display might change.
        // This is no UI, this is a backend request so we separate terms independently.
        const search = searchTerm.join(',');

        return this.http
            .get<SearchResultResponse>('/api/search', {
                ...getOptionsWithTranslateHeader(),
                params: { search },
                observe: 'response',
            })
            .pipe(
                filter((response) => response instanceof HttpResponse),
                mergeMap((response) =>
                    of({
                        result: response.body as SearchResultResponse,
                        triggeredByLanguageChange: response.headers.has(TRANSLATE_REQUEST_HEADER),
                    })
                )
            );
    }
}
